import React from "react";
import Pagelayout from "../../layouts/Pagelayout";
import Realisations from "./realisations/Realisations";

function Landingrealisations() {
  return (
    <Pagelayout
      title="Quelques réalisations"
      description="Nous avons un champs d'impacte diversifié"
    >
      <Realisations />
    </Pagelayout>
  );
}

export default Landingrealisations;
